module.exports = __webpack_public_path__ + "media/images/flags/cy-6bec049b70b6e5cbbaa35384b897f7fe.svg";